export default __webpack_public_path__ + "static/ThinkstockPhotos-508662108_article-908ca34d43237acde7b5b59337cb59c5.jpg";